export default __webpack_public_path__ + "static/general_healthcare_b.07e985cb5a920b9433702ea669e7dfc0.svg";